import React, { Component } from 'react'
import Grid from '@mui/material/Grid'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import _ from 'lodash'
import classNames from 'classnames'
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import Tooltip from '@mui/material/Tooltip'

import ItensExpansionPanel from '../../util/ItensExpansionPanel'
import ItemContextMenu from '../../util/ItemContextMenu'
import { visualizarUrlSistemaLinksPrincipais, sistemas } from '../../../controllers/itensController'
import styles from './VisaoPorAuditorDocumentosQueAtuei.module.css'
import Box from '@mui/material/Box'
import { grey } from '@mui/material/colors'

const IDENTIFICADORES_AGRUPAMENTO = [
  { id: 'documentosPorHistoricoRespAgir', label: 'Responsabilidade por agir' },
  { id: 'documentosPorAssinaturas', label: 'Assinaturas' }
]

export class VisaoPorAuditorDocumentosQueAtuei extends Component {
  constructor(props) {
    super(props)
    this.state = {
      expandedHistory: false
    }
  }

  handleIndicadorComponentClick(
    indicador,
    destaque,
    target = '_blank',
    sistema = sistemas.documentos
  ) {
    const {
      filtros: { responsabilidadeUnidade },
      itens: {
        visao: {
          informacoesAuditor: { codigoUnidadeIntegracao }
        }
      }
    } = this.props
    const indicadorJSON = JSON.stringify(indicador)
    const destaqueJSON = destaque ? JSON.stringify(destaque) : null
    const urlParams =
      `?redirectTo=/${sistema.uri}/detalhar&visao=visaoPorAuditorAgrupador&codigoUnidadeAtual=${codigoUnidadeIntegracao}`.concat(
        `&responsabilidadeUnidade=${responsabilidadeUnidade}&indicador=${indicadorJSON}&destaque=${destaqueJSON}`
      )
    const callback = (url) => window.open(`${url}${urlParams}`, target)
    visualizarUrlSistemaLinksPrincipais(sistema.id, callback)
  }

  handleExpansionPanelChange(expanded) {
    this.setState({ expandedHistory: expanded })
  }

  handleIndicadorComponentItemContextMenuOpen(
    event,
    { indicador, destaque },
    sistema = sistemas.documentos
  ) {
    event.preventDefault()
    this.setState({
      indicadorComponentContextMenuAnchorEl: event.currentTarget,
      indicador,
      destaque,
      sistema
    })
  }

  handleIndicadorComponentItemContextMenuClose() {
    this.setState({
      indicadorComponentContextMenuAnchorEl: null,
      indicador: null,
      destaque: null,
      sistema: null
    })
  }

  handleIndicadorComponentItemContextMenuItemClick(target) {
    const { indicador, destaque, sistema } = this.state
    this.handleIndicadorComponentClick(indicador, destaque, target, sistema)
    this.handleIndicadorComponentItemContextMenuClose()
  }

  renderDocumentosQueInstruiPorTipoItemGrid({ identificador, descricao, total }, index, size) {
    return (
      <Grid
        item
        key={`grid-documentos-que-instrui-por-tipo-${identificador}`}
        className={styles.itemDocumentosQueInstruiClickable}
        onClick={() => this.handleIndicadorComponentClick({ identificador, descricao })}
        onContextMenu={(event) =>
          this.handleIndicadorComponentItemContextMenuOpen(event, {
            indicador: { identificador, descricao }
          })
        }>
        <Grid container direction='row'>
          <Typography variant='body1' color='textSecondary'>
            {descricao}
          </Typography>
          <Typography
            variant='body1'
            color='info.main'
            style={{ textAlign: 'center', paddingLeft: '5px' }}>
            {total}
          </Typography>
        </Grid>
      </Grid>
    )
  }

  renderDocumentosQueInstruiPorItemRangeIdentificadoresGrid({
    identificador,
    descricao,
    total,
    itens
  }) {
    const size = _.size(itens)
    const labelIdentificador = _.find(IDENTIFICADORES_AGRUPAMENTO, (item) =>
      identificador.includes(item.id)
    ).label
    return total ? (
      <Grid
        container
        item
        xs={12}
        key={`grid-documentos-que-instrui-por-tipo-${identificador}`}
        alignItems='stretch'>
        <Grid item container alignItems='center' className={styles.cardItemDocumentosQueInstrui}>
          <Grid item sm={4} lg={3}>
            <Typography
              variant='body1'
              color='textPrimary'
              gutterBottom
              onClick={() => this.handleIndicadorComponentClick({ identificador, descricao })}
              onContextMenu={(event) =>
                this.handleIndicadorComponentItemContextMenuOpen(event, {
                  indicador: { identificador, descricao }
                })
              }>
              <span className={styles.itemDocumentosQueInstruiClickable}>
                {labelIdentificador}{' '}
                <span className={styles.totalDocumentosPorSituacaoServidor}>{total}</span>
              </span>
            </Typography>
          </Grid>
          <Grid item sm={8} lg={9} style={{ paddingLeft: 12 }} className={styles.gridItemTipo}>
            <Grid container spacing={1}>
              {_.map(itens, (item, index) =>
                this.renderDocumentosQueInstruiPorTipoItemGrid(item, index, size)
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    ) : (
      <Grid
        container
        item
        xs={12}
        className={styles.cardItemDocumentosQueInstrui}
        alignItems='center'
        key={`grid-documentos-que-instrui-por-tipo-${identificador}`}>
        <Grid item>
          <Typography variant='body1' color='textPrimary'>
            --
          </Typography>
        </Grid>
      </Grid>
    )
  }

  renderDocumentosQueInstruiPorRangeItemCard(range, itensRangeIdentificadores) {
    const { descricao } = _.first(itensRangeIdentificadores)
    return (
      <Grid
        container
        key={`grid-documentos-que-instrui-por-range-${range}`}
        spacing={1}
        alignItems='stretch'
        style={{ margin: 0, padding: 0 }}>
        <Grid container item sm={3}>
          <Grid
            container
            justifyContent='center'
            alignItems='center'
            className={styles.cardItemDocumentosQueInstrui}>
            <Grid item sm={8}>
              <Tooltip title={descricao}>
                <Typography variant='body1' color='textPrimary'>
                  {range}
                </Typography>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
        <Grid container item sm={9}>
          {_.map(itensRangeIdentificadores, (item) =>
            this.renderDocumentosQueInstruiPorItemRangeIdentificadoresGrid(item)
          )}
        </Grid>
      </Grid>
    )
  }

  renderDocumentosQueInstruiSummaryGrid() {
    const {
      itens: {
        visao: {
          documentosQueAtueiPorAuditor: { identificador, descricao, total }
        }
      }
    } = this.props
    const { expandedHistory } = this.state
    const ehClicavel = total && expandedHistory
    return (
      <Box width={1} display='flex' alignItems='center' key={`summary-${identificador}`}>
        <Box style={{ flexGrow: 1 }}>
          <Typography color='textPrimary' className={styles.titleExpansionSumary} gutterBottom>
            {descricao}
          </Typography>
        </Box>
        <Box
          className={classNames(
            styles.numeradorBoxHistorico,
            styles.totalBox,
            styles.ajusteDistancia
          )}
          onClick={() =>
            ehClicavel ? this.handleIndicadorComponentClick({ identificador, descricao }) : null
          }
          onContextMenu={(event) =>
            ehClicavel
              ? this.handleIndicadorComponentItemContextMenuOpen(event, {
                  indicador: { identificador, descricao }
                })
              : null
          }>
          <Typography
            variant='body2'
            color='white'
            style={{ textAlign: 'center', fontWeight: '100', fontSize: '1.45rem' }}>
            {total}
          </Typography>
        </Box>
      </Box>
    )
  }

  renderDocumentosQueInstruiItensExpansionPanelDetailsGrid() {
    const {
      itens: {
        visao: {
          documentosQueAtueiPorAuditor: { itensMap }
        }
      }
    } = this.props
    return (
      <Grid
        container
        key={`grid-documentos-que-instrui-details`}
        alignItems='stretch'
        style={{ margin: '16px 0', padding: '16px', backgroundColor: grey[100] }}>
        {_.map(itensMap, (item, range) =>
          this.renderDocumentosQueInstruiPorRangeItemCard(range, item)
        )}
      </Grid>
    )
  }

  renderDocumentosQueInstruiCard() {
    let isExpanded = this.state.expandedHistory
    return (
      <Card
        style={{
          borderRadius: '12px',
          position: 'relative',
          padding: isExpanded ? '10px 16px' : '0 16px'
        }}>
        <ItensExpansionPanel
          numItensVisiveis={1}
          noBadge
          expandIcon={<KeyboardArrowDown />}
          expandedIcon={<KeyboardArrowUp />}
          expanded={isExpanded}
          onChange={(event, expanded) => this.handleExpansionPanelChange(expanded)}
          itensComponents={[]
            .concat(this.renderDocumentosQueInstruiSummaryGrid())
            .concat(this.renderDocumentosQueInstruiItensExpansionPanelDetailsGrid())}
        />
      </Card>
    )
  }

  render() {
    const { indicadorComponentContextMenuAnchorEl } = this.state
    return (
      <Grid item xs={12}>
        {this.renderDocumentosQueInstruiCard()}
        <ItemContextMenu
          itemContextMenuAnchorEl={indicadorComponentContextMenuAnchorEl}
          handleItemContextMenuClose={this.handleIndicadorComponentItemContextMenuClose.bind(this)}
          handleItemContextMenuItemClick={this.handleIndicadorComponentItemContextMenuItemClick.bind(
            this
          )}
        />
      </Grid>
    )
  }
}

const mapStateToProps = ({ filtros, itens }) => ({ filtros, itens })

const reduxEnhanced = connect(mapStateToProps)(VisaoPorAuditorDocumentosQueAtuei)

export default withRouter(reduxEnhanced)
